<template>
  <main class="styles-app-structure-main" :class="($route.params.event) ? 'event-opened' : ''">
    <section class="styles-app-structure-section MyBets-styles-section">
      <h1 class="styles-app-structure-title">Bahislerim</h1>
      <div class="MyBetsSettledTab-styles-results-meta" style="display: none">
        <div class="MyBetsSettledTab-styles-filters-button" id="mybets-filter">
          <img src="/static/assets/img/filter.svg" id="mybets-filter-icon">
          <div class="MyBetsSettledTab-styles-filters-label">Filter</div>
        </div>
      </div>

      <div class="MyBetsTabSet-styles-my-bets-tabs">
        <button @click="getNavFilter(nav)" v-for="nav in navFilterData" testid="Button_tab_button_1" id="tab-button-1" class="Button-styles-button TabButton-styles-tab-button MyBetsTabSet-styles-tab-button" :class="(nav.id === selectedNavFilter.id) ? 'TabButton-styles-tab-button-active' : ''" data-id="tab_1"><div class="">{{ nav.title }}</div></button>

      </div>

      <div v-if="bets.length === 0" class="MyBetsInfo-styles-my-bets-info-page">
        <img class="MyBetsInfo-styles-icon" src="/static/assets/img/empty-tray.svg"><div class="MyBetsInfo-styles-title">You have no open bets</div><div class="MyBetsInfo-styles-description">Place bets now.</div></div>

      <div class="MyBetsListDesktop-styles-my-bets MyBetsListDesktop-styles-my-bets-loaded">
        <li class="MyBetsListDesktop-styles-bet" v-for="(bet, bi) in bets" :key="bet.id" @click="openBet(bet.id)">
          <div class="Paper-styles-paper">
            <div class="CollapsibleItem-styles-collapsible-item">
              <div class="MyBetsListItemDesktop-styles-bet-header MyBetsListItemDesktop-styles-bet-header-closed">
                <div class="MyBetsListItemDesktop-styles-bet-data MyBetsListItemDesktop-styles-bet-status" :class="bet.result.key == 'waiting' ? 'MyBetsListItemDesktop-styles-delivered' : bet.result.key == 'win' || bet.result.key == 'cashout' ? 'MyBetsListItemDesktop-styles-paid-out' : bet.result.key == 'loss' ? 'MyBetsListItemDesktop-styles-lost' : 'MyBetsListItemDesktop-styles-lost'" v-text="bet.result.key == 'waiting' ? t.betting.waiting : bet.result.key == 'win' ? t.betting.win : bet.result.key == 'loss' ? t.betting.loss : bet.result.key == 'cashout' ? t.betting.cashout : t.betting.cancelled"></div>
                <div class="MyBetsListItemDesktop-styles-bet-data">{{ bet.created_at | moment('D.M HH:mm', session.timezone)}}</div>
                <div class="MyBetsListItemDesktop-styles-bet-data" v-if="bet.type.name === 'single' || bet.type.name === 'multiple'">{{ bet.odd_count }}x {{ t[bet.type.name] }}</div>
                <div class="MyBetsListItemDesktop-styles-bet-data" v-if="bet.type.name === 'system'">{{ t[bet.type.name] }} ({{ bet.combinations }})</div>
                <div class="MyBetsListItemDesktop-styles-bet-data"><span class="MyBetsListItemDesktop-styles-bet-data-header">Stake</span>
                  <span class="">{{ bet.amount | toMoney(session.currency) }}</span>
                </div>
                <div class="MyBetsListItemDesktop-styles-bet-data MyBetsListItemDesktop-styles-possible-win">
                  <span class="MyBetsListItemDesktop-styles-bet-data-header">{{ t.betting.title.possible_earnings }}</span>
                  <span class="" v-if="bet.calculated_earnings > 0">{{ bet.calculated_earnings  | toMoney(session.currency) }}</span>
                  <span class="" v-if="bet.calculated_earnings === 0">{{ bet.earnings | toMoney(session.currency) }}</span>
                </div>
                <div class="MyBetsListItemDesktop-styles-bet-data MyBetsListItemDesktop-styles-cashout-buttons">
                  <div class="CashoutButton-styles-cashout-button CashoutButton-styles-wide-button">
                    <cashoutButton :bet="bet" :bi="bi" @cashouted="removeTicket" />
                  </div>
                </div>
              </div>
              <betDetail v-if="currentBet === bet.id" :betid="currentBet" />
            </div>
          </div>
        </li>
        <div v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"></div>
      </div>


    </section>

    <aside id="aside" class="styles-app-structure-aside">

      <div class="Aside-styles-aside-wrapper">
        <betSlip />
      </div>
      <topRewards />
    </aside>
  </main>
</template>

<script>

import topRewards from '@/components/sportsbook/widget/topRewards';
import BetSlip from '@/components/sportsbook/BetSlip';
import betDetail from '@/components/user/account/betDetail'
import myBetsCouponDetail from '@/components/user/account/myBetsCouponDetail';
import Paginate from 'vuejs-paginate'

import DatePicker from 'vuejs-datepicker';
import {tr, en} from 'vuejs-datepicker/dist/locale'
import cashoutButton from "../../sportsbook/widget/cashoutButton";

export default {
  name: 'myBets',
  components: {cashoutButton, topRewards, BetSlip, Paginate, betDetail, myBetsCouponDetail, DatePicker},
  data() {
    return {
      selectedResult: '',
      session: session,
      t: this.$root.t,
      notfound: false,
      bets: [],
      tr: tr,
      pagination: null,
      page: 1,
      status: null,
      sDate: false,
      dateSelection: false,
      couponDetail: null,
      currentBet: null,
      navFilterData: [
        {
          id: 1,
          title: this.$root.t.betting.title.open_bets,
          status: 1
        },
        {
          id: 2,
          title: 'Cashout',
          status: [6]
        },
        {
          id: 3,
          title: this.$root.t.fixture.live_bets,
          status: 90
        },
        {
          id: 4,
          title: this.$root.t.betting.title.processed_bets,
          status: [2,3,4,5,6,7,8]
        },
        {
          id: 0,
          title: this.$root.t.betting.all,
          status: [1,2,3,4,5,6,7,8]
        },
      ],
      selectedNavFilter: {
        id: 1,
        title: this.$root.t.betting.title.open_bets,
        status: 1
      },
      dayFilterData: [
        {
          id: 1,
          title: 'Son 15 Gun',
          count: 15
        },
        {
          id: 2,
          title: 'Son 1 Hafta',
          count: 7
        },
        {
          id: 3,
          title: 'Son 1 Yil',
          count: 365
        },
      ],
      dropOpen: false,
      dropTitle: {
        id: 0,
        title: 'Son 30 Gun',
        count: 5
      },
      datePicker: {
        to: null,
        from: null,
        err: false,
      },
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
      },
    }
  },
  watch: {
    '$route.query'() {
      this.fetchBets(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.status);
    },
    '$route.query.id'(n, o) {
      if (n > 0) {
        this.getBetDetail(n);
      }
    },
  },
  mounted() {
    this.fetchBets(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.status);

    if (this.$route.query.id) {
      this.getBetDetail(this.$route.query.id);
    }
    ;

  },
  methods: {
    removeTicket (bi) {
      console.log(bi)
      this.bets.splice(bi, 1);
    },
    onWaypoint({el, going, direction}) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        //console.log('waypoint going in!');

        this.fetchBets(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.status, 1);
        //console.log(`#${el.getAttribute('m')}`)
      }

      if (going === this.$waypointMap.GOING_OUT) {
        //console.log(direction)
      }

      if (direction === this.$waypointMap.DIRECTION_TOP) {
        //console.log('waypoint going top!')
      }
    },
    openBet(b) {

      if(this.currentBet == b){
        this.currentBet = 0;
      }else {
        this.currentBet = b;
      }
    },
    getNavFilter(item) {
      this.page = 1;
      this.selectedNavFilter = item;
      this.fetchBets(this.sDate, this.dropTitle.count, this.datePicker, item.status);
    },
    rangeDate() {
      if (this.datePicker.from !== null && this.datePicker.to !== null) {
        this.datePicker.err = false;
        this.fetchBets(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.status);
      } else {
        this.datePicker.err = true;
      }
    },
    dayFilter(item) {
      this.datePicker.from = null;
      this.datePicker.to = null;
      this.dropTitle = item;
      this.dropOpen = false;
      this.fetchBets(this.sDate, item.count, this.datePicker, this.selectedNavFilter.status);
    },
    couponDetailOpen(detailId) {
      if (this.couponDetail === detailId) {
        this.couponDetail = null
      } else {
        this.couponDetail = detailId;
      }
    },
    sortDate(sDate) {
      this.sDate = !this.sDate;
      this.fetchBets(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.status);
    },
    getBetDetail(id) {
      this.$router.push({
        name: 'mybets',
        query: {id: id, status: this.$route.query.status}
      });
      this.$refs.umodal.open();
    },
    onChangePage(page) {
      this.pagination.current = page;
      this.$router.push({query: {page: page}});


      window.scroll(0, 0);
    },
    async closeModal() {
      this.$router.push({
        name: 'mybets',
        query: {id: null, status: this.$route.query.status}
      });
      setTimeout(() => {
        window.document.body.style.overflowY = "auto"
      }, 500)
    },
    async fetchBets(dir, dateFilter, dateRange, navFilter, loadMore = 0) {

      if(loadMore && this.bets && this.bets.length === 0)
        return false;

      if(this.page == 1)
        this.bets = [];

      this.$http.get(api + 'api/v1/bets', {
        params: {
          //status: this.$route.query.status,
          status: (navFilter === 90) ? null : navFilter,
          isLive: (navFilter === 90) ? true : null,
          page: this.page,
          sort: 'b.createdAt',
          direction: dir ? 'asc' : 'desc',
        }
      })
          .then(response => {

             this.$bus.$emit('globalLoader', false);

            if(!response.body.result){
              if(!loadMore)
                this.bets = [];

              this.notfound = 1;
              this.pagination = null;
              return false;
            }

            if(!loadMore)
              this.bets = response.body.result.bets;

            if(loadMore){
              response.body.result.bets.forEach((v) => {
                this.bets.push(v);
              })
            }

            this.page++;

            this.pagination = response.body.pagination;
            this.notfound = 0;
          }, response => {

              this.$bus.$emit('globalLoader', false);
          })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.betList .nav-link span {
  display: inline-block;
}

.betList .col-12 {
  padding: 0 !important;
}

.betList .os-tabs-controls {
  padding: 0;
  margin-bottom: 1rem;
}

.betList .os-tabs-controls .nav-tabs {
  background: #fff;
  display: block;
  border: 1px solid #ccc;
}

.betList .nav-tabs .nav-item {
  border-right: 1px solid #ccc;
  width: 16.6666%;
  text-align: center;
  float: left;
}

.betList .nav-tabs .nav-item:last-child {
  border-right: 0;
}

.betList .nav-tabs .nav-link:after, .betList .nav-tabs .nav-item .nav-link:after {
  height: 1px;
}

.betList .nav-tabs .nav-link.active, .betList .nav-tabs .nav-item.show .nav-link, .betList .nav-tabs .nav-link:hover, .betList .nav-tabs .nav-item:hover .nav-link {
  background: #003366;
  color: #fff;
  border-radius: 0;
}

.betList .table thead {
  background: #fff;
  line-height: 10px;
}

.betList .table thead tr th {
  border: none;
  font-size: 11px;
  color: #000;
  border-right: 1px solid #ccc;
  text-align: center;
  text-transform: capitalize;
}

.betList .table tbody tr {
  border-radius: 0;
  background: #fff;
}

.betList .table tbody tr:nth-child(2n+1) {
  background: #ebebeb;
}

.betList .table tbody td:first-child {
  border-radius: 0 !important;
}

.betList .table tbody td {
  border-right: 1px solid #ccc;
  border-radius: 0;
  background: none;
}

.betList .table tbody td:last-child {
  border-radius: 0 !important;
}

.betList .table tbody td {
  font-size: 13px !important;
  padding: 0.50rem !important;
}

.d-contents {
  display: contents;
}

.betList .bet-detail {
  position: relative;
  display: flex;
  width: 160%;
  background: #fff;
  padding: 20px;
  border-top: 1px solid #ccc;
}


/*bahis alanı*/

.new-sheet .sheet_body {
  line-height: 24px;
  border: 1px solid #ccc;
  border-top: 1px solid #d6d6d6;
}

.sheet_body_cont .marg_txt {
  line-height: 14px;
  padding: 5px 0 0 20px;
  position: relative;
  background: #fff;
  display: inline-flex;
}

.sheet_body_cont .marg_txt div {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-right: 5px;
  margin-top: 2px;
}

.sheet_body_cont .marg_txt .danger {
  background: red;
}

.sheet_body_cont .marg_txt .win {
  background: green;
}

.sheet_body_cont .marg_txt .wait {
  background: darkblue;
}

.sheet_body_cont .marg_txt .cancelled {
  background: grey;
}

.lightred, a.lightred {
  font-size: 12px;
}


.legendBox {
  margin-bottom: 5px;
}

.legend {
  height: 24px;
  width: 100px;
  float: left;
  font-weight: bold;
  font-size: 13px;
  line-height: 24px;
}

.legend.cf {
  padding-left: 6px;
  width: auto;
  min-width: 51px;
  text-transform: capitalize;
  margin-left: 14px;
}

.legend.blue {
  border-left: 3px solid blue;
}

.legend.green {
  border-left: 3px solid green;
}

.legend.red {
  border-left: 3px solid red;
}

.legend.dark-blue {
  border-left: 3px solid darkblue;
}

.legend.grey {
  border-left: 3px solid grey;
}

.legend.black {
  border-left: 3px solid black;
}

.legendFlex {
  display: flex;
  width: 100%;
  background: #fff;
  padding: 10px;
}

.uline {
  position: relative;
  cursor: pointer;
}

.sort-i {
  font-size: 10px;
  position: absolute;
  bottom: -7px;
  font-weight: 700;
}

#datePicker {
  padding-left: 12px;
  text-transform: capitalize;
  padding-bottom: 2px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

#datePicker .text-danger {
  margin-left: 10px;
}

.vdp-datepicker__calendar header {
  background: #123366;
  width: 100%;
  height: 40px;
}

.vdp-datepicker__calendar header span {
  color: #fff;
}

.vdp-datepicker__calendar {
  width: 220px !important;
  padding: 5px;
  background: #eeeeee !important;
}

.vdp-datepicker__calendar .cell {
  height: inherit !important;
  line-height: 17px !important;
  width: 13% !important;
  margin: 1.3px;
}

.vdp-datepicker__calendar .day {
  border: 1px solid #7c7c7c !important;
  font-size: 11px;
  color: #7c7c7c !important;
  text-align: right !important;;
  background: #fff;
}

.vdp-datepicker__calendar .day.blank {
  border: none !important;
}

.vdp-datepicker__calendar .cell.selected {
  background: #123366 !important;
  color: #fff !important;
}

.vdp-datepicker__calendar .cell.day-header {
  color: #000 !important;
  font-weight: 500;
}

span.prev {
  color: #fff;
  background: #fff;
  width: 20px !important;
  height: 20px;
  border-radius: 100%;
  margin-top: 10px;
  margin-left: 10px;
}

span.next {
  color: #fff;
  background: #fff;
  width: 20px !important;
  height: 20px;
  border-radius: 100%;
  margin-top: 10px;
}

span.next:hover span.prev:hover {
  background: #fff !important;
}

.vdp-datepicker__calendar header .prev:after {
  border-right: 10px solid #123366 !important;
}

.vdp-datepicker__calendar header .next:after {
  border-left: 10px solid #123366 !important;
}

.day__month_btn.up:hover {
  background: #123366 !important;
}


</style>



// WEBPACK FOOTER //
// src/components/user/account/myBets.vue